import iconCalmo from "./icon_calmo.png";
import iconMail from "./icon_mail.png";
import iconPen from "./icon_pen.png";
import iconPositiveNegative from "./icon_positive_negative.png";
import iconQuestion from "./icon_question.png";
import iconRelogio from "./icon_relogio.png";
import iconSend from "./icon_send.png";
import iconSuitCase from "./icon_suitcase.png";
import iconLearn from "./icon_learn.png";

export {
  iconCalmo,
  iconMail,
  iconPen,
  iconPositiveNegative,
  iconQuestion,
  iconRelogio,
  iconSend,
  iconSuitCase,
  iconLearn,
};

export function BackArrow() {
  return (
    <svg
      width="17"
      height="14"
      viewBox="0 0 17 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.332 8C15.8843 8 16.332 7.55228 16.332 7C16.332 6.44772 15.8843 6 15.332 6L3.40622 6L7.68046 1.70543C8.07006 1.31398 8.06856 0.680815 7.67711 0.291218C7.28566 -0.098379 6.65249 -0.0968769 6.2629 0.294573L0.291298 6.29457C0.175179 6.41124 0.0937843 6.54942 0.0471172 6.69624C0.0298405 6.75049 0.017067 6.80676 0.00923729 6.86459C-0.00297165 6.95442 -0.00297165 7.04558 0.00923729 7.13541C0.0170536 7.19315 0.0298004 7.24933 0.0470371 7.30351C0.0936909 7.45042 0.175112 7.58869 0.291298 7.70543L6.2629 13.7054C6.65249 14.0969 7.28566 14.0984 7.67711 13.7088C8.06856 13.3192 8.07006 12.686 7.68046 12.2946L3.40622 8H15.332Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function Download() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.0834 13.9824V17.1121C19.0834 17.5271 18.9185 17.9251 18.625 18.2186C18.3316 18.512 17.9336 18.6769 17.5185 18.6769H6.56482C6.1498 18.6769 5.75178 18.512 5.45832 18.2186C5.16486 17.9251 5 17.5271 5 17.1121V13.9824"
        stroke="white"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.40674 11L11.9067 15L16.4067 11"
        stroke="white"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.9067 15V4"
        stroke="white"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function ToastGreen() {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="22" height="22" fill="#1BA853" />
      <path
        d="M16.3332 7L8.99984 14.3333L5.6665 11"
        stroke="white"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function ToastRed() {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="22" height="22" fill="#C00F00" />
      <path
        d="M16.3332 5.6665L5.6665 16.3332"
        stroke="white"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.6665 5.6665L16.3332 16.3332"
        stroke="white"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function ExitGreen() {
  return (
    <svg
      width="8"
      height="8"
      viewBox="0 0 8 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.66683 1.3335L1.3335 6.66683"
        stroke="#2CA92A"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.3335 1.3335L6.66683 6.66683"
        stroke="#2CA92A"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function ExitRed() {
  return (
    <svg
      width="8"
      height="8"
      viewBox="0 0 8 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.66683 1.3335L1.3335 6.66683"
        stroke="#A50000"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.3335 1.3335L6.66683 6.66683"
        stroke="#A50000"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function MenuHome() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 9L12 2L21 9V20C21 20.5304 20.7893 21.0391 20.4142 21.4142C20.0391 21.7893 19.5304 22 19 22H5C4.46957 22 3.96086 21.7893 3.58579 21.4142C3.21071 21.0391 3 20.5304 3 20V9Z"
        stroke="black"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 22V12H15V22"
        stroke="black"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function MenuTrilha() {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.46825 17.4167H14.5307M12 2.25V3.875M18.8943 5.10567L17.6875 6.3125M21.75 12H20.125M3.875 12H2.25M6.3125 6.3125L5.10567 5.10567M8.16933 15.8307C7.41194 15.0731 6.8962 14.1079 6.68731 13.0572C6.47842 12.0065 6.58577 10.9175 6.99579 9.92781C7.40581 8.93813 8.10008 8.09225 8.99081 7.49712C9.88155 6.90199 10.9287 6.58434 12 6.58434C13.0713 6.58434 14.1185 6.90199 15.0092 7.49712C15.8999 8.09225 16.5942 8.93813 17.0042 9.92781C17.4142 10.9175 17.5216 12.0065 17.3127 13.0572C17.1038 14.1079 16.5881 15.0731 15.8307 15.8307L15.237 16.4233C14.8976 16.7627 14.6284 17.1657 14.4447 17.6092C14.2611 18.0527 14.1666 18.5281 14.1667 19.0081V19.5833C14.1667 20.158 13.9384 20.7091 13.5321 21.1154C13.1257 21.5217 12.5746 21.75 12 21.75C11.4254 21.75 10.8743 21.5217 10.4679 21.1154C10.0616 20.7091 9.83333 20.158 9.83333 19.5833V19.0081C9.83333 18.0385 9.44767 17.1079 8.763 16.4233L8.16933 15.8307Z"
        stroke="#222222"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function MenuAssesment() {
  return (
    <svg
      width="20"
      height="22"
      viewBox="0 0 20 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.7998 20.5668L11.6861 20.4866C11.6711 20.4759 10.181 19.4335 8.5095 19.4335C7.96257 19.4335 7.45172 19.5465 6.99139 19.769C6.23548 20.1355 5.33797 20.321 4.32348 20.321C2.6875 20.321 1.29206 19.8379 1.13842 19.7826L0.999805 19.7331"
        stroke="#FF4D0D"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.9092 1.96311C15.1318 1.75294 15.3959 1.58623 15.6867 1.47248C15.9774 1.35874 16.2891 1.3002 16.6038 1.3002C16.9185 1.3002 17.2301 1.35874 17.5208 1.47248C17.8116 1.58623 18.0758 1.75294 18.2983 1.96311C18.5208 2.17327 18.6973 2.42278 18.8178 2.69737C18.9382 2.97197 19.0002 3.26628 19.0002 3.5635C19.0002 3.86072 18.9382 4.15503 18.8178 4.42963C18.6973 4.70423 18.5208 4.95373 18.2983 5.1639L6.86017 15.9666L2.2002 17.1669L3.4711 12.7658L14.9092 1.96311Z"
        fill="#FF4D0D"
        stroke="#FF4D0D"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function MenuAssesmentBlack() {
  return (
    <svg
      width="20"
      height="22"
      viewBox="0 0 20 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.7998 20.5668L11.6861 20.4866C11.6711 20.4759 10.181 19.4335 8.5095 19.4335C7.96257 19.4335 7.45172 19.5465 6.99139 19.769C6.23548 20.1355 5.33797 20.321 4.32348 20.321C2.6875 20.321 1.29206 19.8379 1.13842 19.7826L0.999805 19.7331"
        stroke="black"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.9092 1.96311C15.1318 1.75294 15.3959 1.58623 15.6867 1.47248C15.9774 1.35874 16.2891 1.3002 16.6038 1.3002C16.9185 1.3002 17.2301 1.35874 17.5208 1.47248C17.8116 1.58623 18.0758 1.75294 18.2983 1.96311C18.5208 2.17327 18.6973 2.42278 18.8178 2.69737C18.9382 2.97197 19.0002 3.26628 19.0002 3.5635C19.0002 3.86072 18.9382 4.15503 18.8178 4.42963C18.6973 4.70423 18.5208 4.95373 18.2983 5.1639L6.86017 15.9666L2.2002 17.1669L3.4711 12.7658L14.9092 1.96311Z"
        fill="none"
        stroke="black"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function MenuCiclo() {
  return (
    <svg
      width="22"
      height="21"
      viewBox="0 0 22 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.0882 5.92067H9.42488M14.0882 5.92067V2.58448C14.0882 1.85052 13.4886 1.25 12.7558 1.25H10.7572C10.0244 1.25 9.42488 1.85052 9.42488 2.58448V5.92067M14.0882 5.92067V15.262M9.42488 5.92067V15.262M9.42488 15.262V18.5982C9.42488 19.3322 10.0244 19.9327 10.7572 19.9327H12.7558C13.4886 19.9327 14.0882 19.3322 14.0882 18.5982V15.262M9.42488 15.262H14.0882M20.75 7.18843H16.0867M20.75 7.18843V4.25258C20.75 3.51861 20.1504 2.9181 19.4176 2.9181H17.4191C16.6863 2.9181 16.0867 3.51861 16.0867 4.25258V7.18843M20.75 7.18843V15.7291H16.0867V7.18843M7.72044 7.62431L3.11916 6.86521M7.72044 7.62431L8.19684 4.72749C8.31593 4.00328 7.82178 3.31316 7.09872 3.19387L5.12674 2.86854C4.40369 2.74925 3.71465 3.24419 3.59555 3.96839L3.11916 6.86521M7.72044 7.62431L6.33457 16.0514L1.73328 15.2923L3.11916 6.86521M19.4176 19.9327H17.4191C16.6863 19.9327 16.0867 19.3322 16.0867 18.5982V15.6624H20.75V18.5982C20.75 19.3322 20.1504 19.9327 19.4176 19.9327ZM4.33781 19.9823L2.36583 19.6569C1.64277 19.5376 1.14862 18.8475 1.26772 18.1233L1.74411 15.2265L6.3454 15.9856L5.869 18.8824C5.7499 19.6066 5.06087 20.1015 4.33781 19.9823Z"
        stroke="black"
        strokeWidth="1.2"
        stroke-miterlimit="10"
      />
    </svg>
  );
}

export function PencilFilledIcon() {
  return (
    <>
      <svg
        width="20"
        height="22"
        viewBox="0 0 20 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.7998 20.5668L11.6861 20.4865C11.6711 20.4759 10.181 19.4335 8.5095 19.4335C7.96257 19.4335 7.45172 19.5465 6.99139 19.769C6.23548 20.1354 5.33797 20.321 4.32348 20.321C2.6875 20.321 1.29206 19.8378 1.13842 19.7826L0.999805 19.733"
          stroke="#FF4D0D"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.9092 1.96308C15.1318 1.75291 15.3959 1.5862 15.6867 1.47245C15.9774 1.35871 16.2891 1.30017 16.6038 1.30017C16.9185 1.30017 17.2301 1.35871 17.5208 1.47245C17.8116 1.5862 18.0758 1.75291 18.2983 1.96308C18.5208 2.17324 18.6973 2.42275 18.8178 2.69734C18.9382 2.97194 19.0002 3.26625 19.0002 3.56347C19.0002 3.86069 18.9382 4.155 18.8178 4.4296C18.6973 4.7042 18.5208 4.9537 18.2983 5.16387L6.86017 15.9665L2.2002 17.1668L3.4711 12.7657L14.9092 1.96308Z"
          fill="#FF4D0D"
          stroke="#FF4D0D"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
}

export function DropdownIconLine() {
  return (
    <svg
      width="18"
      height="10"
      viewBox="0 0 18 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 9L9 1L17 9"
        stroke="black"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function GaleriaDesafiosSelect() {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_434_7513)">
        <rect x="0.5" width="24" height="24" fill="url(#pattern0)" />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M4.74688 2.66445C4.74688 2.33308 4.47825 2.06445 4.14688 2.06445C3.8155 2.06445 3.54688 2.33308 3.54688 2.66445V21.3977C3.54688 21.7291 3.8155 21.9977 4.14688 21.9977C4.47825 21.9977 4.74688 21.7291 4.74688 21.3977V2.66445ZM7.8666 2.06445C8.19797 2.06445 8.4666 2.33308 8.4666 2.66445V21.3977C8.4666 21.7291 8.19797 21.9977 7.8666 21.9977C7.53523 21.9977 7.2666 21.7291 7.2666 21.3977V2.66445C7.2666 2.33308 7.53523 2.06445 7.8666 2.06445ZM10.5 21.0001V3.42783C10.5 2.73387 11.1896 2.25088 11.8417 2.48804L20.8417 5.76077C21.2369 5.90447 21.5 6.28005 21.5 6.70056V21.0001C21.5 21.5524 21.0523 22.0001 20.5 22.0001H11.5C10.9477 22.0001 10.5 21.5524 10.5 21.0001Z"
          fill="#FF4D0D"
        />
      </g>
      <defs>
        <pattern
          id="pattern0"
          patternContentUnits="objectBoundingBox"
          width="1"
          height="1"
        >
          <use transform="translate(-2.60682 1.69715) scale(0.0416667)" />
        </pattern>
        <clipPath id="clip0_434_7513">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0.5)"
          />
        </clipPath>
        <image id="image0_434_7513" width="260" height="42" />
      </defs>
    </svg>
  );
}

export function GaleriaDesafios() {
  return (
    <svg
      width="18"
      height="20"
      viewBox="0 0 18 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M1.24648 0.664453C1.24648 0.333082 0.977849 0.0644531 0.646478 0.0644531C0.315107 0.0644531 0.0464783 0.333082 0.0464783 0.664453V19.3977C0.0464783 19.7291 0.315107 19.9977 0.646478 19.9977C0.977849 19.9977 1.24648 19.7291 1.24648 19.3977V0.664453ZM4.3662 0.0644531C4.69758 0.0644531 4.9662 0.333082 4.9662 0.664453V19.3977C4.9662 19.7291 4.69758 19.9977 4.3662 19.9977C4.03483 19.9977 3.7662 19.7291 3.7662 19.3977V0.664453C3.7662 0.333082 4.03483 0.0644531 4.3662 0.0644531ZM8.1996 18.8001H16.7996V4.84065L8.1996 1.71337V18.8001ZM6.9996 1.42783V19.0001C6.9996 19.5524 7.44732 20.0001 7.9996 20.0001H16.9996C17.5519 20.0001 17.9996 19.5524 17.9996 19.0001V4.70056C17.9996 4.28005 17.7365 3.90447 17.3413 3.76077L8.34134 0.48804C7.68916 0.250882 6.9996 0.733869 6.9996 1.42783Z"
        fill="black"
      />
    </svg>
  );
}

export function SelectedContentsIcon() {
  return (
    <svg width="19" height="22" viewBox="0 0 19 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1 21.3261L1 1" stroke="#F26818" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M1 14.7267C1 14.7267 2.9125 13.9348 6.1 13.9348C9.2875 13.9348 10.2792 15.1667 13.4667 15.1667C16.6542 15.1667 18 13.9348 18 13.9348V1C18 1 16.0875 2.14389 12.9 2.14389C9.7125 2.14389 8.4375 1 5.25 1C2.0625 1 1 2.14389 1 2.14389V14.7267Z"
        fill="#F26818"
        stroke="#F26818"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function ContentsIcon() {
  return (
    <svg width="19" height="22" viewBox="0 0 19 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1 21.3261L1 1" stroke="#222222" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M1 14.7267C1 14.7267 2.9125 13.9348 6.1 13.9348C9.2875 13.9348 10.2792 15.1667 13.4667 15.1667C16.6542 15.1667 18 13.9348 18 13.9348V1C18 1 16.0875 2.14389 12.9 2.14389C9.7125 2.14389 8.4375 1 5.25 1C2.0625 1 1 2.14389 1 2.14389V14.7267Z"
        stroke="#222222"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function SelectedAutoThinking() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask id="path-1-inside-1_377_42952" fill="white">
        <path d="M7.51788 20C7.02788 18.402 6.28888 17.211 5.30038 16.4265C3.81788 15.25 1.46238 15.9815 0.592384 14.7675C-0.277616 13.5535 1.20188 11.3215 1.72088 10.0045C2.24038 8.6875 -0.269116 8.222 0.0238842 7.848C0.218884 7.5985 1.48738 6.8795 3.82838 5.69C4.49338 1.8965 6.94988 0 11.1989 0C17.5719 0 19.9999 5.403 19.9999 8.84C19.9999 12.2765 17.0599 15.9785 12.8719 16.777C12.4974 17.322 13.0374 18.397 14.4919 20.0005" />
      </mask>
      <path
        d="M7.51788 20C7.02788 18.402 6.28888 17.211 5.30038 16.4265C3.81788 15.25 1.46238 15.9815 0.592384 14.7675C-0.277616 13.5535 1.20188 11.3215 1.72088 10.0045C2.24038 8.6875 -0.269116 8.222 0.0238842 7.848C0.218884 7.5985 1.48738 6.8795 3.82838 5.69C4.49338 1.8965 6.94988 0 11.1989 0C17.5719 0 19.9999 5.403 19.9999 8.84C19.9999 12.2765 17.0599 15.9785 12.8719 16.777C12.4974 17.322 13.0374 18.397 14.4919 20.0005"
        fill="#F26818"
      />
      <path
        d="M6.37061 20.3518C6.5649 20.9854 7.23605 21.3416 7.86968 21.1473C8.5033 20.953 8.85945 20.2818 8.66516 19.6482L6.37061 20.3518ZM5.30038 16.4265L6.04636 15.4865L6.04634 15.4865L5.30038 16.4265ZM1.72088 10.0045L0.604591 9.56417L0.604446 9.56454L1.72088 10.0045ZM0.0238842 7.848L0.968518 8.58805L0.96937 8.58696L0.0238842 7.848ZM3.82838 5.69L4.37197 6.75982C4.70865 6.58875 4.94515 6.26917 5.01036 5.8972L3.82838 5.69ZM12.8719 16.777L12.6471 15.5982C12.3366 15.6574 12.0619 15.8368 11.8829 16.0974L12.8719 16.777ZM13.6031 20.8067C14.0483 21.2976 14.8072 21.3346 15.2981 20.8893C15.789 20.444 15.826 19.6852 15.3807 19.1943L13.6031 20.8067ZM8.66516 19.6482C8.12676 17.8924 7.27797 16.464 6.04636 15.4865L4.55441 17.3665C5.29979 17.958 5.92901 18.9116 6.37061 20.3518L8.66516 19.6482ZM6.04634 15.4865C4.99623 14.6532 3.67151 14.5261 2.87293 14.4213C2.41338 14.3609 2.10332 14.3131 1.86159 14.2335C1.64329 14.1617 1.58829 14.0971 1.56778 14.0685L-0.383009 15.4665C0.0314763 16.0449 0.597166 16.3441 1.11154 16.5133C1.60248 16.6748 2.13708 16.7453 2.56047 16.8008C3.52776 16.9279 4.12204 17.0233 4.55443 17.3665L6.04634 15.4865ZM1.56778 14.0685C1.55858 14.0557 1.51304 13.9893 1.52646 13.7695C1.54057 13.5386 1.61566 13.2314 1.76015 12.8438C1.90236 12.4624 2.08748 12.0653 2.28544 11.6521C2.47184 11.2631 2.68745 10.8248 2.83732 10.4445L0.604446 9.56454C0.494818 9.84273 0.330867 10.1772 0.121075 10.6151C-0.0771523 11.0288 -0.304842 11.5125 -0.488633 12.0054C-0.670137 12.4922 -0.834239 13.053 -0.86907 13.6232C-0.904582 14.2045 -0.808813 14.8723 -0.383009 15.4665L1.56778 14.0685ZM2.83718 10.4448C3.12662 9.71106 2.98405 9.02279 2.62984 8.49544C2.32541 8.0422 1.88884 7.73923 1.59209 7.55426C1.43224 7.45462 1.2751 7.36695 1.15194 7.29851C1.01544 7.22266 0.935794 7.17844 0.876828 7.1414C0.788238 7.08575 0.880467 7.12719 0.982792 7.25933C1.04387 7.33822 1.17028 7.52776 1.19565 7.81311C1.22433 8.13568 1.10971 8.40782 0.968517 8.58805L-0.920749 7.10795C-1.09857 7.33493 -1.22792 7.65454 -1.19492 8.02565C-1.16523 8.35956 -1.01546 8.59873 -0.914819 8.72871C-0.733367 8.96305 -0.497212 9.1125 -0.399856 9.17366C-0.272877 9.25343 -0.12456 9.33483 -0.0138545 9.39635C0.110188 9.46528 0.219496 9.52675 0.322552 9.59099C0.425344 9.65506 0.503809 9.71088 0.561879 9.7598C0.62114 9.80972 0.638846 9.83557 0.637535 9.83362C0.633022 9.8269 0.605373 9.78184 0.595328 9.70538C0.590529 9.66886 0.591196 9.63506 0.594983 9.60698C0.596798 9.59352 0.599122 9.58292 0.601107 9.57544C0.602088 9.57175 0.602955 9.56894 0.603584 9.56703C0.603898 9.56608 0.604149 9.56537 0.604323 9.56489C0.604496 9.56441 0.604591 9.56417 0.604591 9.56417L2.83718 10.4448ZM0.96937 8.58696C0.880199 8.70105 0.831435 8.70739 1.03374 8.57348C1.18369 8.47423 1.40681 8.33917 1.71336 8.16532C2.3237 7.81918 3.20705 7.35174 4.37197 6.75982L3.28479 4.62018C2.10872 5.21776 1.18731 5.70457 0.529411 6.07768C0.201831 6.26345 -0.075046 6.42927 -0.290943 6.57218C-0.454479 6.68042 -0.73493 6.8702 -0.921601 7.10904L0.96937 8.58696ZM5.01036 5.8972C5.30418 4.2211 5.96507 3.09635 6.90294 2.37231C7.85578 1.63671 9.24307 1.2 11.1989 1.2V-1.2C8.9057 -1.2 6.94023 -0.688461 5.43633 0.472564C3.91745 1.64515 3.01759 3.3654 2.64641 5.4828L5.01036 5.8972ZM11.1989 1.2C13.9987 1.2 15.8587 2.36698 17.0469 3.87407C18.2687 5.4238 18.7999 7.36588 18.7999 8.84H21.1999C21.1999 6.87712 20.5171 4.3992 18.9316 2.38818C17.3125 0.33452 14.772 -1.2 11.1989 -1.2V1.2ZM18.7999 8.84C18.7999 11.6554 16.3146 14.899 12.6471 15.5982L13.0966 17.9558C17.8051 17.058 21.1999 12.8976 21.1999 8.84H18.7999ZM11.8829 16.0974C11.2954 16.9523 11.6189 17.9239 11.9238 18.5306C12.2667 19.2131 12.8511 19.9777 13.6031 20.8067L15.3807 19.1943C14.6782 18.4198 14.2653 17.8452 14.0682 17.453C13.8331 16.9851 14.0739 17.1467 13.8609 17.4566L11.8829 16.0974Z"
        fill="#F26818"
        mask="url(#path-1-inside-1_377_42952)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.74966 5.25043C7.42266 6.51743 7.51966 7.40743 8.04116 7.91943C8.56216 8.43193 9.45016 8.76693 10.7052 8.92443C10.4202 10.5594 10.7677 11.3259 11.7467 11.2249C12.7257 11.1239 13.3142 10.7174 13.5117 10.0049C15.0417 10.4349 15.8712 10.0749 15.9997 8.92493C16.1922 7.19993 15.2622 5.82443 14.8807 5.82443C14.4997 5.82443 13.5117 5.77793 13.5117 5.25043C13.5117 4.72293 12.3577 4.42543 11.3162 4.42543C10.2747 4.42543 10.9012 3.72293 9.47116 4.00043C8.51766 4.18543 7.94366 4.60193 7.74966 5.25043V5.25043Z"
        stroke="white"
        strokeWidth="1.2"
        strokeLinejoin="round"
      />
      <path
        d="M13.2491 10.75C12.7406 11.0655 12.0431 11.59 11.7491 12C11.0146 13.025 10.4191 13.6485 10.2891 14.304"
        stroke="white"
        strokeWidth="1.2"
        strokeLinecap="round"
      />
    </svg>
  );
}

export function AutoThinking() {
  return (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.51788 21C8.02788 19.402 7.28888 18.211 6.30038 17.4265C4.81788 16.25 2.46238 16.9815 1.59238 15.7675C0.722384 14.5535 2.20188 12.3215 2.72088 11.0045C3.24038 9.6875 0.730884 9.222 1.02388 8.848C1.21888 8.5985 2.48738 7.8795 4.82838 6.69C5.49338 2.8965 7.94988 1 12.1989 1C18.5719 1 20.9999 6.403 20.9999 9.84C20.9999 13.2765 18.0599 16.9785 13.8719 17.777C13.4974 18.322 14.0374 19.397 15.4919 21.0005"
        stroke="#222222"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.74966 6.25043C8.42266 7.51743 8.51966 8.40743 9.04116 8.91943C9.56216 9.43193 10.4502 9.76693 11.7052 9.92443C11.4202 11.5594 11.7677 12.3259 12.7467 12.2249C13.7257 12.1239 14.3142 11.7174 14.5117 11.0049C16.0417 11.4349 16.8712 11.0749 16.9997 9.92493C17.1922 8.19993 16.2622 6.82443 15.8807 6.82443C15.4997 6.82443 14.5117 6.77793 14.5117 6.25043C14.5117 5.72293 13.3577 5.42543 12.3162 5.42543C11.2747 5.42543 11.9012 4.72293 10.4712 5.00043C9.51766 5.18543 8.94366 5.60193 8.74966 6.25043V6.25043Z"
        stroke="#222222"
        strokeWidth="1.2"
        strokeLinejoin="round"
      />
      <path
        d="M14.2491 11.75C13.7406 12.0655 13.0431 12.59 12.7491 13C12.0146 14.025 11.4191 14.6485 11.2891 15.304"
        stroke="#222222"
        strokeWidth="1.2"
        strokeLinecap="round"
      />
    </svg>
  );
}